import { MainAppResource } from './base';

export default MainAppResource('api/v3/projects{/code}/zones{/zone_code}');
